import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Lots from "@/pages/Lots";
import LotDetail from "@/pages/LotDetail";
import Items from "@/pages/Items";
import Sales from "@/pages/Sales";
import Settings from "@/pages/Settings";
import Financeiro from "@/pages/Financeiro";
import DRE from "@/pages/DRE";
import Despesas from "@/pages/Despesas";
import Metas from "@/pages/Metas";
import Analises from "@/pages/Analises";
import Membros from "@/pages/Membros";
import PlanoAssinatura from "@/pages/PlanoAssinatura";
import Auditoria from "@/pages/Auditoria";
import Platform from "@/pages/Platform";
import Onboarding from "@/pages/Onboarding";
import AcceptInvite from "@/pages/AcceptInvite";
import { Loader2 } from "lucide-react";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-accent" /></div>;
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/" element={<Dashboard />} />
        <Route path="/lotes" element={<Lots />} />
        <Route path="/lotes/:id" element={<LotDetail />} />
        <Route path="/mercadorias" element={<Items />} />
        <Route path="/vendas" element={<Sales />} />
        <Route path="/configuracoes" element={<Settings />} />
        <Route path="/financeiro" element={<Financeiro />} />
        <Route path="/dre" element={<DRE />} />
        <Route path="/despesas" element={<Despesas />} />
        <Route path="/metas" element={<Metas />} />
        <Route path="/analises" element={<Analises />} />
        <Route path="/membros" element={<Membros />} />
        <Route path="/auditoria" element={<Auditoria />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/plano" element={<PlanoAssinatura />} />
        <Route path="/onboarding" element={<Onboarding />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
